import * as c from '../constants/constant_action_types';

export function storeSummaryInitType(summary_type) {
  return {
    type: c.INITIALIZE_SUMMARY_TYPE,
    payload: {
      summary_type
    }
  };
}

export function storeSummaryFetching(summary_type) {
  return {
    type: c.FETCHING_SUMMARY_TYPE,
    payload: {
      summary_type
    }
  };
}

export function storeSummaryFetched(payload) {
  return {
    type: c.SUCCESS_FETCHING_SUMMARY_TYPE,
    payload
  };
}

export function storeSummaryError(payload) {
  return {
    type: c.ERROR_FETCHING_SUMMARY_TYPE,
    payload
  };
}

export function querySummaries(filters, requrestType) {
  return {
    type: c.QUERY_SUMMARIES,
    payload: {
      filters,
      requrestType
    }
  };
}

export function fetchSummaryTypeData(payload) {
  return {
    type: c.FETCH_SUMMARY_TYPE_DATA,
    payload
  };
}

export function exportToDoc(payload) {
  return {
    type: c.EXPORT_STORE_SUMMARY_TO_DOC,
    payload
  };
}
